import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isMemberSignedIn, loadMemberWatchlistFilms, memberHasWatchlistFilm } from '@vista-digital/occ-domain';
import { useLoadAction } from '@vista-digital/react-tools';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { Icon } from '../../../subcomponents/icon/icon';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultFilmWatchlistButtonProps, filmWatchlistButtonPropsValidator } from './types/props';
import { toggleFilmInWatchlist } from './utils/toggle-film-in-watchlist';
const b = bemClassBuilder('v-film-watchlist-button');
export const FilmWatchlistButton = observer(props => {
    const { i18n, assets: occAssets, config: { film: filmConfig }, displayText: { film: filmDisplayText } } = useOccContext();
    const { config, events } = props;
    const { film } = useFilmContext();
    const { iconOnly } = config;
    if (!filmConfig.showWatchlistButtons)
        return null;
    const isSignedIn = isMemberSignedIn();
    const loadAction = useCallback(() => {
        if (isSignedIn)
            return loadMemberWatchlistFilms();
    }, [isSignedIn]);
    useLoadAction(loadAction);
    if (!film)
        return null;
    const isFilmInWatchlist = memberHasWatchlistFilm(film.id);
    const label = isFilmInWatchlist
        ? filmDisplayText.removeFromWatchlistButtonLabel
        : filmDisplayText.addToWatchlistButtonLabel;
    const handleClick = (event) => {
        // Prevent the event from bubbling up.
        event.preventDefault();
        event.stopPropagation();
        toggleFilmInWatchlist(film, events, filmDisplayText, isFilmInWatchlist !== null && isFilmInWatchlist !== void 0 ? isFilmInWatchlist : false, i18n);
    };
    return (_jsx("button", { className: b.block({ active: isFilmInWatchlist, iconOnly }), onClick: handleClick, "aria-label": iconOnly ? label : undefined, children: _jsxs("span", { className: b.element('wrapper'), children: [_jsx(Icon, { className: b.element('icon'), name: occAssets.filmWatchlistButtonIconName }), !iconOnly && label && _jsx("span", { className: b.element('label'), children: label })] }) }));
});
FilmWatchlistButton.displayName = 'FilmWatchlistButton';
/**
 * The **Film Watchlist Button** renders a button that allows a currently logged-in member to add or remove a film from their watchlist.
 */
export const FilmWatchlistButtonComponent = withComponentWrapper(FilmWatchlistButton, defaultFilmWatchlistButtonProps, filmWatchlistButtonPropsValidator);
//# sourceMappingURL=film-watchlist-button.js.map